import { icons } from 'assets';
import Button from 'Components/shared/button';
import Modal from 'Components/shared/modal';
import Text from 'Components/shared/text';
import React from 'react';

const Receipt = ({onClose, openModal, data,...props}) => {
    const entries = Object.entries(data);
    const downloadReceiptHandler = () => {

    }
    return (
        <Modal open={openModal} onClose={onClose} disableBackdropClick variant='dark' >
            
                    <div>
                        <div style={{width:"70%", margin:"auto", textAlign:"center"}}>
                            
                            <Text variant="md2" style={{fontWeight:800, paddingBottom:"8px"}}>
                            Receipt
                            </Text>
                            <Text color="secondary">your transaction reciept</Text>
                            
                        </div>
                        <div className="row-start" style={{marginTop:"24px", gap:"1rem", flexDirection:"column"}}>
                            {
                                entries.map(([key, value]) => (
                                    <Row key={key} label={key} value={value} />
                                ))
                            }
                        </div>
                        <div className="row-start" style={{marginTop:"34px", gap:"1rem", marginBottom:"54px"}}>
                            <Button onClick={downloadReceiptHandler} style={{backgroundColor:"var(--secondary-color)", minWidth:"0", flexGrow:1}}>Download Receipt</Button>
                            <Button onClick={onClose}> Close</Button>
                        </div>
                    </div>
               
            
        </Modal>
    )
}

const Row = ({label, value}) => {
    return (
        <div className="row-start w-full" style={{justifyContent:"space-between", borderBottom:"1px solid #E2E8F0",paddingBottom:"1rem"}}>
            <Text variant="sm" color="secondary">{label}</Text>
            <Text variant="sm" style={{fontWeight:700}}>{value}</Text>
        </div>
    )
}

export default Receipt;